import React, { useState } from "react";
import Header from "./Header";
import { Link, useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const ForgotPassword = (props) => {
  const navigate = useNavigate();
  const [forgotDetails, setForgotDetails] = useState({
      email: "",
    }),
    [loading, setLoading] = useState(false),
    [errorMessage, setErrorMessage] = useState(""),
    [userAuth, setUserAuth] = useState("");

  // Hadle user Auth
  const getUserAuth = (userData) => {
    const token = userData.data.authToken;
    setUserAuth(token);
  };

  // Handle error message
  const handleErrorMessage = (err) => {
    const error = err.message[0].msg || err.message;
    setErrorMessage(error);
  };

  const handleChange = (event) => {
    setForgotDetails((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = {
      email: forgotDetails.email,
    };
    console.log(data);
    // turn the loading effect
    setLoading(true);

    try {
      const response = await fetch(
        `https://studyapp-api.vercel.app/api/v1/password-reset/send-otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      const responseData = await response.json();
      // console.log(responseData);

      // Handle the error message
      handleErrorMessage(responseData);

      // update the userAuth token
      getUserAuth(responseData);

      //Update the email value state
      setForgotDetails((prev) => {
        return {
          ...prev,
          ...responseData,
        };
      });
      //   console.log(email);

      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  localStorage.setItem("authToken", userAuth);

  return (
    <div>
      <Header />
      <section className="forgot-password">
        <form className="form-container" onSubmit={handleSubmit}>
          <div className="form-wrapper">
            <div className="form-header">
              <h3>forgot password</h3>
            </div>
            <div className="form-body">
              <div className="form-field">
                <label htmlFor="email">email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={forgotDetails.email}
                  onChange={handleChange}
                />
              </div>
            </div>
            {/* return error message*/}
            {forgotDetails.status === "success" ? (
              <span style={{ color: "green" }}>{errorMessage} </span>
            ) : (
              <span style={{ color: "red" }}>{errorMessage}</span>
            )}
            <div className="form-footer">
              <div className="form-field">
                <div className="flex-2">
                  <div className="cta-btn">
                    <Link to="/login">back</Link>
                  </div>
                  <div className="cta-btn">
                    {forgotDetails.status === "success" ? (
                      // <button>resend code</button>
                      navigate("/reset-password-token")
                    ) : (
                      <button>submit</button>
                    )}
                  </div>
                </div>

                {loading ? (
                  <Backdrop
                    sx={{
                      color: "#fff",
                      zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>
                ) : null}
              </div>
            </div>
          </div>
        </form>
      </section>
    </div>
  );
};

export default ForgotPassword;
